import { queryKeys, type GridPath } from '@/shared/hooks';

export const buildDetailGridQueryKey = (
  path: GridPath,
  tableKey: string,
  entityId: string | null | undefined,
  extraKey: string | null | undefined,
  organisationId: string | null | undefined,
): ReturnType<typeof queryKeys.dataGrid> =>
  queryKeys.dataGrid(
    path,
    tableKey,
    entityId ?? 'unknown',
    extraKey ?? 'default',
    organisationId ?? 'personal',
  );
